import React from 'react';
import {
    Typography,
    Box,
    Chip
} from '@mui/material';
import {
    Phone
} from '@mui/icons-material';
import PhoneItem from './PhoneItem';
import { AddPhoneButton, RemovePhoneButton } from '../EditMode/CompanyDetailEditControls';
import _ from 'lodash';
import { colors } from '../../styles/globals.js';

const PhoneTab = ({ phones, onUpdatePhones }) => {
    if (!phones || phones.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography sx={{ color: colors.textSecondary }}>
                    No phone data found
                </Typography>
                {onUpdatePhones && (
                    <Box sx={{ mt: 2 }}>
                        <AddPhoneButton phones={phones || []} onUpdate={onUpdatePhones} />
                    </Box>
                )}
            </Box>
        );
    }
    // Sort phones so input data appears first
    const sortedPhones = _.sortBy(phones, (phone) => {
        const isInputData = phone.association_type && phone.association_type.includes('INPUT_DATA');
        return isInputData ? 0 : 1; // Input data gets 0 (first), others get 1 (second)
    });

    return (
        <Box>
            {onUpdatePhones && (
                <Box sx={{ mb: 2 }}>
                    <AddPhoneButton phones={phones} onUpdate={onUpdatePhones} />
                </Box>
            )}
            {_.map(sortedPhones, (phone, index) => {
                const isInputData = phone.association_type && phone.association_type.includes('INPUT_DATA');

                return (
                    <Box key={phone.id || index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <PhoneItem phone={phone} isInputData={isInputData} />
                        </Box>
                        {onUpdatePhones && (
                            <RemovePhoneButton
                                phoneId={phone.id}
                                phones={phones}
                                onUpdate={onUpdatePhones}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
};

export default PhoneTab;
